"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitComponentKey = exports.handleContentWidthWithOffset = exports.handleContentWidth = exports.giveRandomNumber = exports.generateComponentId = exports.generateBgAndPropertiesNew = exports.generateBgAndProperties = exports.extractComponentInfo = exports.debugMessage = exports.bannerBuildBGImg = exports.addMediaQuery = exports.addCustomCssRule = void 0;
var _constants = require("./constants");
const giveRandomNumber = (min, max) => Math.floor(Math.random() * max) + min;
exports.giveRandomNumber = giveRandomNumber;
const generateComponentId = (componentName, aditionalId = '', id = giveRandomNumber(1, 999)) => {
  return `${componentName}-${id}${aditionalId ? `-${aditionalId}` : ''}`;
};
exports.generateComponentId = generateComponentId;
const handleContentWidth = (widthUnit, widthContent) => {
  let res = '';
  switch (widthUnit) {
    case _constants.WIDTH_UNIT.PERCENTAGE:
      {
        const nCol = parseInt(parseInt(widthContent, 10) * 12 / 100, 10);
        res = `col-lg-${nCol} col-sm-6 col-xs-12`;
      }
      break;
    case _constants.WIDTH_UNIT.COLUMNS:
      res = `col-lg-${widthContent} col-sm-6 col-xs-12`;
      break;
    default:
      res = {
        width: `${widthContent}px`
      };
      break;
  }
  return res;
};
exports.handleContentWidth = handleContentWidth;
const handleContentWidthWithOffset = (widthUnit, widthContent) => {
  let res = '';
  switch (widthUnit) {
    case _constants.WIDTH_UNIT.PERCENTAGE:
      {
        const nCol = parseInt(parseInt(widthContent, 10) * 12 / 100, 10);
        res = `col-lg-${nCol} off-lg-${12 - nCol} col-sm-6 off-sm-6 col-xs-12`;
      }
      break;
    case _constants.WIDTH_UNIT.COLUMNS:
      res = `col-lg-${widthContent} off-lg-${12 - widthContent} col-sm-6 off-sm-6 col-xs-12`;
      break;
    default:
      res = {
        width: `${widthContent}px`
      };
      break;
  }
  return res;
};
exports.handleContentWidthWithOffset = handleContentWidthWithOffset;
const splitComponentKey = fullKey => {
  const tokkens = fullKey.split('-');
  return {
    componentName: tokkens[0],
    componentId: tokkens[1]
  };
};
exports.splitComponentKey = splitComponentKey;
const extractComponentInfo = components => {
  let componentKeys = Object.keys(components);
  componentKeys = componentKeys.map(componentKey => {
    return splitComponentKey(componentKey);
  });
  return componentKeys;
};
exports.extractComponentInfo = extractComponentInfo;
const addCustomCssRule = (selector, styleStr, desktopMediaquery, minAncho) => {
  let css = '';
  let minWidth = 768;
  if (minAncho && parseInt(minAncho, 10) !== Number.isNaN()) {
    minWidth = parseInt(minAncho, 10);
  }
  if (desktopMediaquery) {
    css += `@media (max-width :${minWidth}px){`;
    css += `${selector} {${styleStr}}`;
    css += '}';
  } else {
    css += `${selector} {${styleStr}}`;
  }
  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  head.appendChild(style);
};
exports.addCustomCssRule = addCustomCssRule;
const addMediaQuery = (selector, styleStr, kind = 'nodevice') => {
  let css = '';
  // 1) deciding media query
  switch (kind) {
    case 'pc':
      css = `${css}@media screen and (min-width: 1260px){`;
      break;
    case 'mobile':
      css = `${css}@media screen and (min-width: 0px) and (max-width: 768px) {`;
      break;
    case 'mobileWhenNoTablet':
      css = `${css}@media screen and (min-width: 0px) and (max-width: 1260px) {`;
      break;
    case 'nodevice':
      css = '';
      break;
    case 'tablet':
    default:
      css = `${css}@media screen and (min-width: 768px) and (max-width: 1260px) {`;
      break;
  }
  // appending instructions
  css += `${selector} {${styleStr}}${kind === 'nodevice' ? '{' : ''}`;
  css += '}';
  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  head.appendChild(style);
};

/* it depends on full or container width */
/* it is important, know how pictures we have */
exports.addMediaQuery = addMediaQuery;
const bannerBuildBGImg = (currentBGImg, idBanner, div2Fit, bgColor, layout) => {
  /* Adding css rules for background image media queries */
  if (div2Fit === 'container') {
    div2Fit = ' .mainContainer';
  } else {
    // carga a full es placebo
    div2Fit = '';
  }
  const node2AplyBG = `${idBanner}${div2Fit}`;

  /* BACKGROUNDS AND SHADES LIMIT */
  if (currentBGImg && currentBGImg.picMobile) {
    const deviceToAttach = !currentBGImg.picTablet ? 'mobileWhenNoTablet' : 'mobile';
    const {
      picMobile
    } = currentBGImg;
    const {
      position,
      size,
      src,
      shadeLimit
    } = picMobile;
    // esta imagen al ser en movil si el div2Fit es container ni mijita tiene que ser a full
    const node2AplyBGOnMobile = `${idBanner}`;
    // cuando es full pic se deja una imagen en lugar de una iamgen de fondo
    if (layout !== _constants.BANNER_KIND.FULLPIC) {
      const bgImage = `url(${src})`;
      addMediaQuery(`#${node2AplyBGOnMobile}`, `background-image: ${bgImage};
        background-size: ${size};
        background-position: ${position};`, deviceToAttach);
    }
    if (!shadeLimit) {
      addMediaQuery(`#${idBanner} .banner_shade_left,
         #${idBanner} .banner_shade_right`, 'display: none', deviceToAttach);
    }
  }
  if (currentBGImg && currentBGImg.picTablet) {
    const {
      picTablet
    } = currentBGImg;
    const {
      position,
      size,
      src,
      shadeLimit
    } = picTablet;
    const bgImage = `url(${src})`;
    addMediaQuery(`#${node2AplyBG}`, `background-image: ${bgImage};
      background-size: ${size};
      background-position: ${position};
      background-repeat: no-repeat;`, 'tablet');
    addMediaQuery(`#${idBanner} .banner_shade_left,
       #${idBanner} .banner_shade_right`, `display: ${shadeLimit ? 'block' : 'none'}`, 'tablet');
  }
  if (currentBGImg && currentBGImg.picDesktop) {
    const {
      picDesktop
    } = currentBGImg;
    const {
      position,
      size,
      src,
      shadeLimit
    } = picDesktop;
    const bgImage = `url(${src})`;
    addMediaQuery(`#${node2AplyBG}`, `background-image: ${bgImage};
      background-size: ${size};
       background-position: ${position};`, 'pc');
    // }

    addMediaQuery(`#${idBanner} .banner_shade_left,
       #${idBanner} .banner_shade_right`, `display: ${shadeLimit ? 'block' : 'none'}`, 'pc');
  }

  /* SET DEFAULT BACKGROUND */
  if (bgColor) {
    addMediaQuery(`#${idBanner}`, `background-color: ${bgColor}`, 'no');
  }
};
exports.bannerBuildBGImg = bannerBuildBGImg;
const generateBgAndProperties = (idBanner, components, layout) => {
  // Tratamiento fondo del banner
  let whereDiv2Fit = '';
  let cssbgColor = '';
  if (components && components['BgImage-1']) {
    const currentBGImg = components['BgImage-1'];
    cssbgColor = `--${currentBGImg.bgColor}`;
    whereDiv2Fit = currentBGImg.div2Fit;
    bannerBuildBGImg(currentBGImg, idBanner, currentBGImg.div2Fit, currentBGImg.bgColor, layout);
  }
  return {
    whereDiv2Fit,
    cssbgColor
  };
};
exports.generateBgAndProperties = generateBgAndProperties;
const generateBgAndPropertiesNew = components => {
  // Tratamiento fondo del banner
  let whereDiv2Fit = '';
  let cssbgColor = '';
  if (components && components['BgImage-1']) {
    const currentBGImg = components['BgImage-1'];
    cssbgColor = `--${currentBGImg.bgColor}`;
    whereDiv2Fit = currentBGImg.div2Fit;
  }
  return {
    whereDiv2Fit,
    cssbgColor
  };
};
exports.generateBgAndPropertiesNew = generateBgAndPropertiesNew;
const debugMessage = (msg, kind = 'log') => {
  const isDev = process.env.NODE_ENV === 'development';
  if (isDev && kind === 'log') {
    console.log(msg);
  }
};
exports.debugMessage = debugMessage;

//# sourceMappingURL=bannerUtils.js.map